/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Gl_1_DInputs */

const en_mk_tut_gl_1_d = /** @type {(inputs: Mk_Tut_Gl_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One company’s working space. Data in one workspace is never visible from another.`)
};

const id_mk_tut_gl_1_d = /** @type {(inputs: Mk_Tut_Gl_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang kerja satu perusahaan. Data satu workspace tidak pernah terlihat dari workspace lain.`)
};

/**
* | output |
* | --- |
* | "One company’s working space. Data in one workspace is never visible from another." |
*
* @param {Mk_Tut_Gl_1_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_gl_1_d = /** @type {((inputs?: Mk_Tut_Gl_1_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Gl_1_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_gl_1_d(inputs)
	return en_mk_tut_gl_1_d(inputs)
});